import type {
  ConditionField,
  ReportField,
  TileConfiguration,
  TileSettings,
} from "../../../../../../../../api/types/svTypes.ts";

export const createTileDataRequest = (conditions: ConditionField[], fields: ReportField[], settings: TileSettings) => {
  const result: TileConfiguration = {
    conditions: conditions.map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
    fields: fields.map((f) => f.config),
    settings,
  };

  return result;
};
